// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CloudIpOwnershipSchema = z.enum(['customer_owned','shared_anycast','ephemeral'] as const);

export type CloudIpOwnershipType = `${z.infer<typeof CloudIpOwnershipSchema>}`

export default CloudIpOwnershipSchema;
